import AboutUnisearchBanner from "@modules/study/common/about_unisearch_banner/about_unisearch_banner";
import DocumentBanner2 from "@modules/study/document/document_banner2";
import DocumentNeed from "@modules/study/document/document_need";
import { LayoutMain } from "@unisearch/theme/layout";

const Documents = () => {
  return (
    <LayoutMain
      footer_with_evaluation
      title="Documents"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/documents`}
    >
      <DocumentBanner2 />
      <AboutUnisearchBanner
        heading={`How UniSearch Helps With Your Application <span className="mark">Documents</span>`}
        shortDescription="Think about your application as though you’re putting together a very specific recipe. For the final product to be perfect, each ingredient needs to be perfect too. In this case, the documents that go into your application package are the ingredients you need in your recipe for success. And we’re the in-house chefs to help you along!"
      />
      <DocumentNeed />
    </LayoutMain>
  );
};

export default Documents;
